import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import './App.scss';
import { DriverPortalInstancesProvider } from './Context/DriverPortalInstancesContext';

function App() {
    return (
        <BrowserRouter>
            <DriverPortalInstancesProvider>
                <Routes />
            </DriverPortalInstancesProvider>
        </BrowserRouter>
    );
}

export default App;
